var _style, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPleca3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 589 51",
    style: {
      enableBackground: "new 0 0 589 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.2;}\n\t.st2{clip-path:url(#SVGID_00000155833465500503368200000005470831482663038107_);}\n\t.st3{fill:url(#SVGID_00000007429194792217694060000015288124055044907658_);}\n\t.st4{fill:url(#SVGID_00000146477080523841983230000012320948814581666484_);}\n\t.st5{fill:url(#SVGID_00000096039725458118664700000004527679516731113861_);}\n\t.st6{fill:url(#SVGID_00000176020419383826877940000010403725592740302491_);}\n\t.st7{fill:url(#SVGID_00000060722195981030203060000015238249209934603963_);}\n\t.st8{fill:url(#SVGID_00000057849254443402492620000009127127809291597192_);}\n\t.st9{fill:url(#SVGID_00000098219315847611113870000013958714824770259602_);}\n\t.st10{fill:url(#SVGID_00000038374342199494880050000003132818520146457476_);}\n\t.st11{fill:url(#SVGID_00000036253639449656709270000009943400525155627158_);}\n\t.st12{fill:url(#SVGID_00000003102498125127888460000005150915622064821683_);}\n\t.st13{fill:url(#SVGID_00000174589195136718291730000015728846317667766923_);}\n\t.st14{fill:url(#SVGID_00000170268232871307470670000007668743285763002774_);}\n\t.st15{fill:url(#SVGID_00000033364711332103491820000001565463254452315044_);}\n\t.st16{fill:url(#SVGID_00000146459385116324089950000001209450499786485690_);}\n\t.st17{fill:url(#SVGID_00000064332899454606442790000007270367410116102565_);}\n\t.st18{fill:url(#SVGID_00000096056949783219281570000018412755146900288899_);}\n\t.st19{fill:url(#SVGID_00000169518320485943139610000009497380423282548113_);}\n\t.st20{fill:url(#SVGID_00000027601291283172817550000017224029068696557467_);}\n\t.st21{fill:url(#SVGID_00000051375733814139324600000003394472856341974922_);}\n\t.st22{fill:url(#SVGID_00000063593023321281768880000001408939071124995206_);}\n\t.st23{fill:url(#SVGID_00000102515608337423643960000012337850956240979338_);}\n\t.st24{fill:url(#SVGID_00000071553280394595542170000017193577934353283235_);}\n\t.st25{fill:url(#SVGID_00000067227934800233323370000004136644114295067523_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.7313,
    y1: 23.8264,
    x2: 294.7313,
    y2: -23.1835,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#313131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C0C0C"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.42,
    y: -0.21,
    className: "st0",
    width: 588.63,
    height: 51.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000184836958649496820000017095587082367896474_",
    x: 0.42,
    y: -0.21,
    width: 588.63,
    height: 51.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176725557901008339260000004660470824499820938_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000184836958649496820000017095587082367896474_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176725557901008339260000004660470824499820938_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081609199932729413520000017199385674330369979_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2603,
    y1: 9.8699,
    x2: 639.7166,
    y2: 9.8699,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602B24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#663127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#865235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#9E6B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B07D47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#BA884C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#B5824A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#98633E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#864F36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#885237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#A06B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#915C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#824D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#8A593A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#966E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A88C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEB05C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081609199932729413520000017199385674330369979_)"
    },
    d: "M267.86,19.22 c-3.48-1.79-6.94-3.65-10.41-5.52c-1.73-0.96-3.46-1.89-5.18-2.87l-5.16-2.92l-2.58-1.46l-2.57-1.49l-5.14-3l-6.27-3.72h-0.64 l6.85,4.04l5.14,2.98l2.57,1.49l2.58,1.46l5.16,2.93c1.71,0.98,3.45,1.92,5.17,2.88c3.46,1.88,6.92,3.74,10.41,5.54l2.61,1.35 l2.62,1.32c1.74,0.89,3.49,1.74,5.25,2.59s3.51,1.67,5.27,2.51c1.76,0.81,3.52,1.64,5.29,2.42 c7.07,3.16,14.2-23.42,21.38-20.84c1.24,0.44,2.49,0.86,3.73,1.29c-1.22-0.79-2.43-1.43-3.65-1.86 C295.92,3.25,281.78,26.41,267.86,19.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059275289741455864220000011789451861019370654_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2603,
    y1: 89.3191,
    x2: 639.7166,
    y2: 89.3191,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602B24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#663127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#865235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#9E6B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B07D47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#BA884C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#B5824A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#98633E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#864F36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#885237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#A06B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#915C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#824D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#8A593A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#966E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A88C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEB05C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059275289741455864220000011789451861019370654_)"
    },
    d: "M10.11-61.88 c0.81-0.31,1.63-0.61,2.45-0.9l0.67-0.24l0.68-0.22l1.35-0.44c0.9-0.29,1.8-0.6,2.71-0.87l2.72-0.77l1.36-0.39 c0.46-0.13,0.91-0.23,1.37-0.35l2.73-0.67l0.68-0.16l0.68-0.14l1.38-0.28c0.91-0.18,1.83-0.39,2.75-0.56l2.76-0.47l1.38-0.23 c0.46-0.07,0.92-0.12,1.38-0.19l2.76-0.38l0.69-0.09l0.69-0.07l1.38-0.14l2.77-0.27l2.77-0.19c0.93-0.06,1.85-0.14,2.77-0.16 c1.85-0.06,3.7-0.16,5.55-0.16c7.4-0.08,14.8,0.33,22.18,1.24c7.37,0.91,14.72,2.3,22.01,4.1c0.91,0.2,1.83,0.46,2.73,0.7 l2.73,0.73l2.72,0.79c0.9,0.27,1.81,0.52,2.71,0.81c2.26,0.68,4.5,1.45,6.74,2.24c1.01,0.03,2.03,0.06,3.04,0.09 c-3.21-1.13-6.42-2.28-9.66-3.26c-0.91-0.29-1.82-0.55-2.73-0.81l-2.73-0.78l-2.73-0.72c-0.91-0.24-1.83-0.5-2.74-0.7 c-7.31-1.79-14.67-3.15-22.07-4.05s-14.81-1.29-22.24-1.19c-1.85,0-3.71,0.11-5.56,0.18c-0.93,0.02-1.85,0.1-2.78,0.17 L45.4-70.5l-2.78,0.29l-1.39,0.15l-0.69,0.08l-0.69,0.1l-2.77,0.4c-0.46,0.07-0.92,0.12-1.38,0.2l-1.38,0.24l-2.76,0.49 c-0.92,0.17-1.83,0.39-2.75,0.58l-1.38,0.29l-0.68,0.14l-0.68,0.17l-2.74,0.69c-0.46,0.12-0.91,0.22-1.37,0.36l-1.36,0.4 l-2.73,0.79c-0.91,0.28-1.81,0.6-2.71,0.89l-1.36,0.45l-0.68,0.22l-0.67,0.25c-1.25,0.45-2.5,0.94-3.74,1.43 C9.17-61.87,9.64-61.87,10.11-61.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111168608234132375620000002550287606415056539_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2603,
    y1: -1.7326,
    x2: 639.7166,
    y2: -1.7326,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602B24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#663127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#865235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#9E6B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B07D47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#BA884C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#B5824A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#98633E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#864F36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#885237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#A06B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#915C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#824D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#8A593A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#966E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A88C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEB05C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111168608234132375620000002550287606415056539_)"
    },
    d: "M337.43,16.87l-2.75-0.64l-1.37-0.32 l-1.37-0.35c-6.04-1.53-12.04-3.34-18.01-5.37c9.31,6.05,18.71,21.76,28.19,31.06c-0.65-8.76-1.3-23.69-1.95-23.81 C339.26,17.26,338.34,17.07,337.43,16.87z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139984258600416794370000015281844213927966650_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2603,
    y1: 99.6856,
    x2: 639.7166,
    y2: 99.6856,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602B24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#663127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#865235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#9E6B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B07D47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#BA884C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#B5824A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#98633E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#864F36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#885237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#A06B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#915C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#824D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#8A593A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#966E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A88C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEB05C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139984258600416794370000015281844213927966650_)"
    },
    d: "M639.7-107.31 c-7.2,2.5-14.31,5.55-21.28,9.08c-0.87,0.43-1.73,0.91-2.6,1.37l-2.6,1.39l-2.6,1.39l-2.58,1.49l-2.57,1.49l-1.28,0.75 c-0.43,0.25-0.85,0.5-1.28,0.77l-5.09,3.18l-1.27,0.79l-1.26,0.83l-2.52,1.68c-1.68,1.12-3.36,2.22-5.01,3.4l-4.98,3.51 l-4.93,3.64c-6.55,4.91-13.04,9.99-19.44,15.28l-2.41,1.97l-2.39,2c-1.59,1.34-3.2,2.66-4.78,4.01l-4.76,4.05l-1.27,1.09 c0.39,0.02,0.78,0.04,1.17,0.05l0.43-0.37l4.75-4.08c1.58-1.36,3.18-2.69,4.77-4.03l2.39-2.01l2.4-1.98 c12.78-10.59,25.8-20.64,39.26-29.37l5.07-3.22c0.42-0.27,0.85-0.52,1.28-0.77l1.28-0.76l2.56-1.51l2.56-1.51l5.18-2.83 c0.87-0.47,1.72-0.97,2.6-1.4c6.96-3.6,14.04-6.71,21.22-9.3L639.7-107.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119103886080414116760000011908276217391979696_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.2603,
    y1: -0.3663,
    x2: 639.7166,
    y2: -0.3663,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#602B24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#663127"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#865235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#9E6B40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B07D47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#BA884C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#B5824A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#98633E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#864F36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#885237"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#A06B41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#BE8C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#915C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#804934"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#824D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#8A593A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#966E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A88C4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEB05C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119103886080414116760000011908276217391979696_)"
    },
    d: "M492.68-1.76 c-0.36,0.28-0.71,0.57-1.07,0.85c-3.24,2.52-6.49,5.03-9.77,7.45c-13.11,9.73-26.58,18.51-40.51,25.58 c-12.66,6.42-22.61,11.32-42.99,15.12c-7.33,1.38-14.72,2.09-22.12,2.28l-1.39,0.04h-4.17c-0.92,0-1.85-0.06-2.77-0.08 c-0.92-0.03-1.85-0.04-2.77-0.1l-2.77-0.17l-1.39-0.09l-1.38-0.13l-2.77-0.25c-0.92-0.09-1.85-0.22-2.76-0.33 c-3.98-0.48-7.95-3.25-11.9-7.14c0.27,3.61,0.54,6.19,0.81,6.23l2.76,0.5l1.38,0.24l1.38,0.21l2.76,0.43 c0.93,0.13,1.85,0.23,2.77,0.36c14.78,1.89,29.71,1.71,44.44-1c20.41-3.75,30.44-8.65,43.16-15.07 c13.99-7.06,27.49-15.87,40.62-25.62c4.06-3.02,8.09-6.13,12.08-9.31H492.68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108989324153265372500000006884291029771035786_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.3743,
    y1: -0.9824,
    x2: -10.6027,
    y2: -0.9824,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108989324153265372500000006884291029771035786_)"
    },
    d: "M89.85,5.73 c-2.91-2.52-5.84-5.01-8.76-7.49H79.4c9.67,8.25,19.27,16.7,28.91,25.05c8.24,7.16,14.91,13.69,34.44,28.43h2.41 c-20.97-15.59-27.79-22.25-36.34-29.62L89.85,5.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018917119405681251470000015605441180823540663_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.3743,
    y1: -0.9824,
    x2: -10.6027,
    y2: -0.9824,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018917119405681251470000015605441180823540663_)"
    },
    d: "M481.77-1.76 c-12.94,6.03-25.69,12.85-38.33,20.06c-13.74,7.87-27.36-13.35-41.02-5.23l-10.26,35.54l-5.14,2.98l-0.24,0.14h2.09l3.58-2.09 l10.25-35.57c13.65-8.17,27.26,13.02,40.98,5.12c13.18-7.56,26.47-14.69,39.98-20.94H481.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001654802178013966040000015466208805546332570_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.3743,
    y1: 23.1787,
    x2: -10.6027,
    y2: 23.1787,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001654802178013966040000015466208805546332570_)"
    },
    d: "M637.73-6.25 c-0.36-0.21-0.72-0.41-1.08-0.62v0.23c0.34,0.2,0.68,0.39,1.02,0.59c6.82,4.07,13.41,8.92,19.65,14.57l0.05-0.11 C651.14,2.73,644.55-2.14,637.73-6.25z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029039926764002020150000015895911815730091405_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.4752,
    y1: 8.4204,
    x2: 679.0319,
    y2: 8.4204,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029039926764002020150000015895911815730091405_)"
    },
    d: "M549.08,32.29l-2.8,0.11 c-0.93,0.04-1.87,0.08-2.8,0.08l-5.61,0.07l-5.61-0.08l-1.4-0.02l-4.21-0.18c-7.48-0.37-14.95-1.05-22.39-2.1 c-7.44-1.09-14.85-2.52-22.22-4.33l-2.76-0.7c-0.92-0.23-1.85-0.46-2.76-0.73l-5.5-1.58l-5.47-1.74l-0.68-0.21l-0.68-0.23 l-1.36-0.47l-2.73-0.95c-14.51-5.13-28.78-11.54-42.96-18.3c-1.86-0.89-3.72-1.79-5.58-2.68h-1.25 c2.24,1.07,4.48,2.16,6.72,3.22c14.18,6.75,28.47,13.15,43,18.26l2.73,0.93l1.36,0.47l0.68,0.23l0.68,0.21l5.48,1.73l5.5,1.56 c0.91,0.27,1.84,0.5,2.76,0.73l2.76,0.69c7.37,1.8,14.8,3.22,22.24,4.3c7.45,1.05,14.93,1.72,22.4,2.06l2.8,0.11l1.4,0.06 l1.4,0.02l5.61,0.07l5.61-0.08c0.93-0.01,1.87-0.05,2.8-0.09l2.8-0.12c7.49-0.36,14.95-1.03,22.4-2.04 c6.72-0.94,13.41-2.16,20.07-3.63c0-0.09,0-0.18,0-0.27c-6.67,1.46-13.37,2.67-20.09,3.6 C564.03,31.28,556.55,31.94,549.08,32.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147925755134269147680000009471839983707900329_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.3673,
    y1: -0.9824,
    x2: 679.1398,
    y2: -0.9824,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147925755134269147680000009471839983707900329_)"
    },
    d: "M181.95-1.76 c-7.86,5.04-15.67,10.24-23.5,15.38c-13.56,8.92-27.2-11.82-41.23-4.5c-7.01,3.66-14.11,36.47-21.31,39.34l-2.7,1.05 l-1.35,0.53c-0.45,0.17-0.91,0.32-1.36,0.48c-1.16,0.4-2.32,0.8-3.48,1.2h2.08c0.5-0.17,0.99-0.34,1.49-0.51 c0.46-0.16,0.91-0.3,1.36-0.48l1.36-0.52l2.71-1.05c7.21-2.86,14.33-35.65,21.35-39.31c14.06-7.3,27.73,13.47,41.3,4.58 c8.25-5.42,16.48-10.91,24.77-16.2H181.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016065435659410974630000016797159871335546010_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.3673,
    y1: 23.4918,
    x2: 679.1398,
    y2: 23.4918,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016065435659410974630000016797159871335546010_)"
    },
    d: "M679.11-11.38 c-13.42,9.37-27.41,17.04-41.7,23.29c-0.25,0.11-0.51,0.21-0.76,0.32v0.17c0.26-0.11,0.53-0.22,0.8-0.33 c14.29-6.28,28.28-13.98,41.69-23.37L679.11-11.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171686091318349234720000001018748640811784067_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.3673,
    y1: -26.4987,
    x2: 679.1398,
    y2: -26.4987,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171686091318349234720000001018748640811784067_)"
    },
    d: "M-0.91,49.28v0.28 c1.39,0.63,3.05,1.34,5.04,2.17H4.9C2.55,50.78,0.65,49.98-0.91,49.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005255445162293203460000012645053628642189722_",
    gradientUnits: "userSpaceOnUse",
    x1: -6221.8794,
    y1: -17.1049,
    x2: -5529.3726,
    y2: -17.1049,
    gradientTransform: "matrix(-1 0 0 1 -5542.7202 -53.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005255445162293203460000012645053628642189722_)"
    },
    d: "M658.52-73.37 c-3.6-1.43-7.26-2.61-10.94-3.55c-3.68-0.95-7.39-1.66-11.12-2.14c-6.84-0.89-13.71-1.15-20.57-0.82 c0.43,0.13,0.86,0.28,1.29,0.44c6.42-0.26,12.86-0.01,19.26,0.8c3.72,0.46,7.43,1.15,11.11,2.06 c3.68,0.91,7.34,2.06,10.94,3.48c7.2,2.84,14.21,6.75,20.65,12.15l0.01-0.05l0.03-0.07 C672.74-66.52,665.72-70.49,658.52-73.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010995946355208882260000017204343592212380863_",
    gradientUnits: "userSpaceOnUse",
    x1: -6221.8794,
    y1: -8.2376,
    x2: -5529.3726,
    y2: -8.2376,
    gradientTransform: "matrix(-1 0 0 1 -5542.7202 -53.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010995946355208882260000017204343592212380863_)"
    },
    d: "M524.49-45.07 c7.94-4.97,15.95-9.7,24.1-13.95c7.01-3.67,14.11-6.99,21.31-9.86l2.7-1.05l1.35-0.53c0.45-0.17,0.91-0.32,1.36-0.48 c1.81-0.62,3.63-1.27,5.44-1.88c3.64-1.19,7.31-2.21,10.99-3.08c2.28-0.54,4.57-1.02,6.86-1.45c0.45-0.29,0.91-0.56,1.39-0.83 c-2.78,0.47-5.55,1.04-8.31,1.68c-3.7,0.86-7.37,1.86-11.03,3.04c-1.82,0.6-3.64,1.25-5.46,1.87 c-0.46,0.16-0.91,0.3-1.36,0.48l-1.36,0.52l-2.71,1.05c-7.21,2.85-14.33,6.16-21.35,9.82c-8.53,4.43-16.92,9.38-25.23,14.58 C523.62-45.12,524.06-45.09,524.49-45.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180333921521161024260000015581551592762196140_",
    gradientUnits: "userSpaceOnUse",
    x1: -6221.8794,
    y1: 62.7181,
    x2: -5529.3726,
    y2: 62.7181,
    gradientTransform: "matrix(-1 0 0 1 -5542.7202 -53.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180333921521161024260000015581551592762196140_)"
    },
    d: "M453.66-1.76 c-9.8,5.16-19.76,9.68-29.91,13.23l-5.46,1.81l-5.49,1.59c-0.91,0.27-1.84,0.48-2.76,0.7l-2.76,0.67l-1.38,0.34 c-0.46,0.12-0.93,0.19-1.39,0.28l-2.78,0.54c-7.4,1.38-14.87,2.13-22.34,2.28c-7.47,0.09-14.95-0.43-22.39-1.43 c-1.86-0.26-3.72-0.48-5.58-0.84l-2.78-0.5c-0.93-0.16-1.86-0.32-2.78-0.53l-5.54-1.19l-5.52-1.38 c-14.67-3.88-29.13-9.28-43.39-15.56h-1.36c0.4,0.18,0.8,0.36,1.19,0.54c14.28,6.32,28.78,11.76,43.5,15.67l5.53,1.39 l5.55,1.21c0.93,0.21,1.86,0.37,2.78,0.54l2.78,0.5c1.85,0.37,3.72,0.6,5.58,0.86c7.45,1.02,14.95,1.54,22.44,1.47 c7.49-0.13,14.98-0.86,22.4-2.25l2.78-0.53c0.46-0.1,0.93-0.16,1.39-0.28l1.38-0.34l2.77-0.66c0.92-0.22,1.85-0.42,2.76-0.7 l5.51-1.58l5.47-1.8c10.7-3.74,21.18-8.56,31.48-14.05H453.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120547214984030397240000007589024732961493143_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -96.8866,
    x2: 602.7908,
    y2: -96.8866,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120547214984030397240000007589024732961493143_)"
    },
    d: "M-42.91,129.72 c-1.35-0.12-2.7-0.26-4.05-0.43c-3.72-0.46-7.43-1.15-11.11-2.06c-3.68-0.91-7.34-2.06-10.93-3.48 c-7.2-2.84-14.21-6.75-20.65-12.15l-0.03,0.06l-0.03,0.07c6.42,5.45,13.44,9.42,20.64,12.3c3.6,1.43,7.26,2.61,10.94,3.55 c3.68,0.95,7.39,1.66,11.12,2.14c1.37,0.18,2.73,0.32,4.1,0.45V129.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055700230763588442340000002071764653084344509_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -99.5203,
    x2: 602.7908,
    y2: -99.5203,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055700230763588442340000002071764653084344509_)"
    },
    d: "M17.79,120.21l-0.93,0.36l-1.35,0.53 c-0.45,0.17-0.91,0.32-1.36,0.48c-1.81,0.62-3.63,1.27-5.44,1.88c-3.19,1.04-6.4,1.94-9.62,2.74v0.63 c3.25-0.79,6.49-1.68,9.7-2.72c1.82-0.6,3.64-1.25,5.46-1.87c0.46-0.16,0.91-0.3,1.36-0.48l1.36-0.52l1.34-0.52L17.79,120.21z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169537965534870692350000008060255879735097275_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -5.3925,
    x2: 602.7908,
    y2: -5.3925,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169537965534870692350000008060255879735097275_)"
    },
    d: "M131.46,51.72 c11.19-13.62,22.6-37.95,34.24-42.02l5.46-1.81l0.06-0.02l-0.16-0.82l-5.47,1.8c-11.91,4.17-23.57,29.41-34.99,42.86H131.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013190170691901834820000005541785059814295702_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: 3.7055,
    x2: 602.7908,
    y2: 3.7055,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013190170691901834820000005541785059814295702_)"
    },
    d: "M176.65,6.31l-5.43,1.57l5.35,27.1 c0.91-0.28,1.85-0.48,2.76-0.7l2.77-0.66l-2.69-28.01C178.49,5.83,177.56,6.04,176.65,6.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139998611638006146660000002030821189386550661_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -5.2147,
    x2: 602.7908,
    y2: -5.2147,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139998611638006146660000002030821189386550661_)"
    },
    d: "M296.65,51.72h1.29 c-14.19-6.66-28.59-41.13-43.21-45.01l-0.13,0.67l0.05,0.01C268.84,11.14,282.84,43.83,296.65,51.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034067331863065412100000002539715744744288390_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -74.8455,
    x2: 602.7908,
    y2: -74.8455,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034067331863065412100000002539715744744288390_)"
    },
    d: "M531.08,93.72 c-0.89,0.26-1.77,0.53-2.66,0.78l-5.52,1.45c-0.92,0.25-1.85,0.45-2.76,0.67l-2.76,0.65c-7.38,1.68-14.8,3.03-22.25,4.06 c-7.45,1-14.92,1.66-22.39,2l-2.8,0.11c-0.93,0.04-1.87,0.08-2.8,0.08l-5.61,0.07l-5.61-0.08l-1.4-0.02l-1.5-0.07 c-0.76,0.1-1.53,0.19-2.29,0.29l2.38,0.09l1.4,0.06l1.4,0.02l5.61,0.07l5.61-0.08c0.93-0.01,1.87-0.05,2.8-0.09l2.8-0.12 c7.49-0.36,14.95-1.03,22.4-2.04c7.45-1.05,14.87-2.41,22.26-4.11l2.76-0.66c0.92-0.23,1.85-0.43,2.76-0.68l5.52-1.46 c1.13-0.33,2.27-0.66,3.4-1H531.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109740741790179860560000001756453691121575337_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: 3.5937,
    x2: 602.7908,
    y2: 3.5937,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109740741790179860560000001756453691121575337_)"
    },
    points: "243.72,33.61 249.2,34.81  254.59,7.38 249.12,6.01  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080891506017343592990000011050803154435994009_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.7164,
    y1: -8.3233,
    x2: 602.7908,
    y2: -8.3233,
    gradientTransform: "matrix(1 0 0 -1 0 24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A16144"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#B67B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D09C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E5B567"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F3C76F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#FCD273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#EFC26D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D5A361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C68F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C8925B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#DCAB65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FDD474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#FFD675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F8CE72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#D09C5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#C18958"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#C38D59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#C9995E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#D4AF67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#E4CC72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F8F281"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFF87"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080891506017343592990000011050803154435994009_)"
    },
    d: "M240.86,33.06l-2.78-0.5 c-1.85-0.37-3.72-0.6-5.58-0.86c-7.45-1.02-14.95-1.54-22.44-1.47c-7.49,0.13-14.98,0.86-22.4,2.25L184.87,33 c-0.46,0.1-0.93,0.16-1.39,0.28l-1.38,0.34l-0.01,0l0.08,0.81l1.38-0.34c0.46-0.12,0.93-0.19,1.39-0.28l2.78-0.54 c7.4-1.38,14.87-2.13,22.34-2.28c7.47-0.09,14.95,0.43,22.39,1.43c1.86,0.26,3.72,0.48,5.58,0.84l2.78,0.5 c0.93,0.16,1.86,0.32,2.78,0.53l0.13-0.69l-0.07-0.02C242.72,33.38,241.79,33.23,240.86,33.06z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleca3);
export default __webpack_public_path__ + "static/media/pleca3.956f092bfb2344b3e4414b7a401b19e4.svg";
export { ForwardRef as ReactComponent };